<div class="message-comments-container">
  <div class="comments-header">
    <h5>
      <svg width="18" height="16" viewBox="0 0 18 16">
        <path id="messages-icon"
          d="M4.2,14.277V13.37l7.819.015a2.345,2.345,0,0,0,2.38-2.3V4.333l.978-1.042A.306.306,0,0,1,15.6,3.2a.321.321,0,0,1,.108.019.291.291,0,0,1,.192.271V6.392h.321A1.753,1.753,0,0,1,18,8.114v6.143a1.753,1.753,0,0,1-1.778,1.723L5.979,16A1.754,1.754,0,0,1,4.2,14.277ZM1.778,12.784A1.754,1.754,0,0,1,0,11.06V4.918A1.753,1.753,0,0,1,1.778,3.2H3.6V.29A.291.291,0,0,1,3.792.019.317.317,0,0,1,3.9,0a.3.3,0,0,1,.221.095L7.033,3.2l4.988.02A1.754,1.754,0,0,1,13.8,4.938v6.142A1.754,1.754,0,0,1,12.02,12.8ZM6.6,9.6a.3.3,0,0,0,.3.29h3.9a.29.29,0,1,0,0-.58H6.9A.3.3,0,0,0,6.6,9.6ZM2.7,7.864a.3.3,0,0,0,.3.291h7.8a.29.29,0,1,0,0-.581H3A.3.3,0,0,0,2.7,7.864Zm0-1.743a.3.3,0,0,0,.3.291h7.8a.29.29,0,1,0,0-.581H3A.3.3,0,0,0,2.7,6.121Z"
          transform="translate(17.999 16) rotate(180)" fill="#ccc" />
      </svg> {{ 'messagesCom.Comments' | translate }} <span>({{commentsObject.numberOfCommentsWithReplies}})</span>
    </h5>

    <span class="comments-sort-label">{{ 'messagesCom.SortedBy' | translate }} :</span>
    <div>
      <mat-form-field class="no-validation">
        <mat-select value="2" (selectionChange)="setSelectedSortItems($event)">
          <mat-option value="0">{{ 'messagesCom.Top' | translate }}</mat-option>
          <mat-option value="1">{{ 'messagesCom.Relevant' | translate }}</mat-option>
          <mat-option value="2">{{ 'messagesCom.Newest' | translate }}</mat-option>
          <mat-option value="3">{{ 'messagesCom.Oldest' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- Add My Comment -->
  <div class="comment-panel" *ngIf="messageDetails.canReply || TaskComment">
    <div class="add-comment">
      <div class="name-with-image">
        <div class="image-circle">
          <img *ngIf="currentUser.profilePicture" [src]="currentUser.profilePicture"
            (error)="currentUser.profilePicture = ''" />
          <span *ngIf="!currentUser.profilePicture">{{ currentUser.name | shortName }}</span>
        </div>
      </div>
      <div class="comment-control">
        <div class="d-flex mb-2" *ngIf='commentAsList.length > 1'>
          <span class="mr-2">As:</span>
          <div>
            <mat-form-field class="comment-as no-validation">
              <mat-select [(ngModel)]="commentAs">
                <mat-option *ngFor="let user of commentAsList" [value]="user">
                  <span>{{user.currentUser ? ("general.Me" | translate) : user.fullName}}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <mat-form-field class="no-validation">
          <textarea matInput maxlength="1000" #comment [(ngModel)]="myComment" (keyup)="textAreaAdjust($event);"
            [placeholder]="'messagesCom.Type your comment here' | translate" style="height: 26px;"></textarea>
        </mat-form-field>
        <div class="btn-container">
          <button *ngIf="trim(myComment) != ''" class="btn customBtn loading" [ngClass]="{loading: loading}"
            (click)="addMyComment($event)">{{ 'messagesCom.AddComment' | translate }}</button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf='dataLoading' class="dataLoading" style="height: auto;">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>

  <div class="comments-list" *ngIf="commentsObject.totalCount > 0 && !dataLoading">
    <div class="comment-panel" *ngFor="let oneComment of commentspageData; index as i;">
      <div class="reply-header d-sm-flex justify-content-between align-items-center">

        <div class="name-with-image mb-3 mb-sm-0">
          <div class="image-circle">
            <img *ngIf="oneComment.creatorData.creatorProfilePicture"
              [src]="oneComment.creatorData.creatorProfilePicture"
              (error)="oneComment.creatorData.creatorProfilePicture = ''" />
            <span *ngIf="!oneComment.creatorData.creatorProfilePicture">{{ oneComment.creatorData.creatorName | shortName }}</span>
          </div>
          <div class="name">
            <h5>{{oneComment.creatorData.creatorName}}<span>({{oneComment.creatorData.creatorUserName}})</span></h5>
            <h6>{{oneComment.creatorData.creatorCollectionName}}</h6>
          </div>

          <div class="delegated-user" *ngIf="oneComment.delegatorData && oneComment.delegatorData.creatorId">
            <img class="delegated-arrow" src="./assets/images/icons/arrow-delegate-icon.svg">
            <div class="image-circle" [title]="oneComment.delegatorData.creatorName">
              <img *ngIf="oneComment.delegatorData.creatorProfilePicture"
                [src]="oneComment.delegatorData.creatorProfilePicture"
                (error)="oneComment.delegatorData.creatorProfilePicture = ''" />
              <span *ngIf="!oneComment.delegatorData.creatorProfilePicture">{{
                oneComment.delegatorData.creatorName | shortName }}</span>
            </div>
          </div>
        </div>

        <div class="text-lg-right">
          <p class="date-time">{{oneComment.created | date:'MMMM dd, hh:mm aaa'}}</p>
          <p class="time-from">{{oneComment.created | timeAgo}}</p>
        </div>
      </div>

      <div class="reply-content">
        <div class="reply-body">
          <pre *ngIf="toggleEditReplay !== 'comment-'+oneComment.commentId">{{oneComment.content}}</pre>
          <div class="comment-control"
            *ngIf="toggleEditReplay == 'comment-'+oneComment.commentId && (messageDetails.canReply || TaskComment)">
            <div class="d-flex mb-2" *ngIf='commentAsList.length > 1'>
              <span class="mr-2">As:</span>
              <div>
                <mat-form-field class="comment-as no-validation">
                  <mat-select [(ngModel)]="commentAs">
                    <mat-option *ngFor="let user of commentAsList" [value]="user">
                      <!-- <img class="example-option-img" height="25"
                                              *ngIf="user.profilePhoto" [src]="user.profilePhoto"
                                              (error)="user.profilePhoto = ''" />
                                          <span class="example-option-img" *ngIf="!user.profilePhoto">
                                              {{ user.fullName | shortName }}
                                          </span> -->
                      <!-- <span>{{user.currentUser ? "Me" : user.fullName}}</span> -->
                      <span>{{user.currentUser ? ("general.Me" | translate) : user.fullName}}</span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <mat-form-field class="no-validation">
              <textarea matInput maxlength="1000" [(ngModel)]="oneComment.content" (keyup)="textAreaAdjust($event);"
                (focus)="textAreaAdjust($event);" [placeholder]="oneComment.content"></textarea>
            </mat-form-field>
            <div class="btn-container">
              <button *ngIf="trim(oneComment.content) != ''" class="btn customBtn" [ngClass]="{loading: replyLoading}"
                (click)="editComment(oneComment)">{{ 'messagesCom.Edit' | translate }}</button>
            </div>
          </div>
        </div>
        <div class="reply-actions">
          <!-- <button class="btn btn-vote active"  [class.active]="voteType == 1" *ngIf="messageDetails.canVote" [disabled]="!messageDetails.canVote">
                      <svg width="17" height="16" viewBox="0 0 17 16">
                          <path id="upvote-icon" d="M7848.208,4410a13.134,13.134,0,0,1-4.674-.922V4400.5a6.245,6.245,0,0,0,1.927-1.255c.963-.97,1.473-3.355,1.473-4.677a.567.567,0,0,1,.566-.57h.467a2.368,2.368,0,0,1,2.366,2.334,9.967,9.967,0,0,1-.567,3.379h4.418a1.786,1.786,0,0,1,1.806,1.515,103.755,103.755,0,0,0-1.241,4.139,1.741,1.741,0,0,1,.118.632,1.713,1.713,0,0,1-1.252,1.654,1.735,1.735,0,0,1-1.7,2.347Zm-8.64,0a.571.571,0,0,1-.567-.573v-9.142a.568.568,0,0,1,.567-.571h2.267a.568.568,0,0,1,.566.571v9.142a.57.57,0,0,1-.566.573Z" transform="translate(-7839.001 -4394)" fill="#ccc"/>
                      </svg> {{oneComment.upVotes}}
                  </button> -->
          <!-- <button class="btn btn-vote"  [class.active]="voteType == 2" *ngIf="messageDetails.canVote" [disabled]="!messageDetails.canVote">
                      <svg width="17" height="16" viewBox="0 0 17 16">
                          <path id="downvote-icon" d="M9.207,0A13.134,13.134,0,0,0,4.533.922V9.5A6.245,6.245,0,0,1,6.46,10.753c.963.97,1.473,3.355,1.473,4.677A.567.567,0,0,0,8.5,16h.467a2.368,2.368,0,0,0,2.366-2.334,9.967,9.967,0,0,0-.567-3.379h4.418a1.786,1.786,0,0,0,1.806-1.515,1.718,1.718,0,0,0-.423-1.343,1.72,1.72,0,0,0-.818-2.8A1.741,1.741,0,0,0,15.866,4a1.713,1.713,0,0,0-1.252-1.654A1.735,1.735,0,0,0,12.914,0ZM.567,0A.571.571,0,0,0,0,.573V9.715a.568.568,0,0,0,.567.571H2.833A.568.568,0,0,0,3.4,9.715V.573A.57.57,0,0,0,2.833,0Z" fill="#ccc"/>
                      </svg> {{oneComment.downVotes}}
                  </button> -->
          <!-- <span class="sep" *ngIf="messageDetails.canReply"></span> -->
          <button class="btn" *ngIf="messageDetails.canReply || TaskComment"
            (click)="canReply('comment-'+oneComment.commentId)">{{ 'messagesCom.Reply' | translate }}</button>
          <span class="sep" *ngIf="(messageDetails.canReply || TaskComment) && oneComment.isCreator"></span>
          <button class="btn" *ngIf="(messageDetails.canReply || TaskComment) && oneComment.isCreator"
            (click)="canComment('comment-'+oneComment.commentId)">{{ 'messagesCom.Edit' | translate }}</button>
        </div>
        <!-- Add Reply panel level one -->
        <div class="comment-panel"
          *ngIf="toggleAddReplay == 'comment-'+oneComment.commentId && (messageDetails.canReply || TaskComment)">
          <div class="add-comment">
            <div class="name-with-image">
              <div class="image-circle">
                <img *ngIf="currentUser.profilePicture" [src]="currentUser.profilePicture"
                  (error)="currentUser.profilePicture = ''" />
                <span *ngIf="!currentUser.profilePicture">{{ currentUser.name | shortName }}</span>
              </div>
            </div>
            <div class="comment-control">
              <div class="d-flex mb-2" *ngIf='commentAsList.length > 1'>
                <span class="mr-2">As:</span>
                <div>
                  <mat-form-field class="comment-as no-validation">
                    <mat-select [(ngModel)]="commentAs">
                      <mat-option *ngFor="let user of commentAsList" [value]="user">
                        <!-- <img class="example-option-img" height="25"
                                                  *ngIf="user.profilePhoto" [src]="user.profilePhoto"
                                                  (error)="user.profilePhoto = ''" />
                                              <span class="example-option-img" *ngIf="!user.profilePhoto">
                                                  {{ user.fullName | shortName }}
                                              </span> -->
                        <!-- <span>{{user.currentUser ? "Me" : user.fullName}}</span> -->
                        <span>{{user.currentUser ? ("general.Me" | translate) : user.fullName}}</span>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <mat-form-field class="no-validation">
                <textarea matInput maxlength="1000" [(ngModel)]="commentReply" (keyup)="textAreaAdjust($event);"
                  (focus)="textAreaAdjust($event);"
                  [placeholder]="'messagesCom.Type your reply here' | translate"></textarea>
              </mat-form-field>
              <div class="btn-container">
                <button class="btn customBtn" *ngIf="trim(commentReply) != ''" [ngClass]="{loading: replyLoading}"
                  (click)="addReply(oneComment.commentId, oneComment.commentId)">{{ 'messagesCom.Reply' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- End Add Reply panel level one -->
        <ng-container *ngIf="oneComment.haveReplies">
          <!-- Show Replies Btn -->
          <div>
            <button class="btn show-replies"
              [ngClass]="{'loading black': repliesListLoading == 'loading-' + oneComment.commentId}"
              (click)="getReplies(oneComment.commentId, oneComment.commentId)">
              <span *ngIf="!returnRepliesList(oneComment.commentId, oneComment.commentId)">{{ 'messagesCom.ShowReplies' | translate
                }}</span>
              <span *ngIf="returnRepliesList(oneComment.commentId, oneComment.commentId)">{{ 'messagesCom.HideReplies' | translate
                }}</span>
              <svg width="5" height="9" viewBox="0 0 5 9">
                <path id="show-replies-icon"
                  d="M7839,4398.7l.758-.7,1.742,1.606,1.742-1.6.758.695-2.5,2.3Zm2.5-5.3-1.742,1.606-.758-.7,2.5-2.3,2.5,2.3-.758.7Z"
                  transform="translate(-7839 -4392)" fill="#aaa" />
              </svg>
            </button>
          </div>
          <!-- End Show Replies Btn -->
          <div class="replies-list" *ngIf="returnRepliesList(oneComment.commentId, oneComment.commentId)">
            <div class="reply-item"
              *ngFor="let oneReply of returnRepliesList(oneComment.commentId, oneComment.commentId); index as indxR;">
              <div class="comment-panel">
                <div class="reply-header d-sm-flex justify-content-between align-items-center">
                  <div class="name-with-image mb-3 mb-sm-0">
                    <div class="image-circle">
                      <img *ngIf="oneReply.creatorData.creatorProfilePicture"
                        [src]="oneReply.creatorData.creatorProfilePicture"
                        (error)="oneReply.creatorData.creatorProfilePicture = ''" />
                      <span *ngIf="!oneReply.creatorData.creatorProfilePicture">{{
                        oneReply.creatorData.creatorName | shortName }}</span>
                    </div>
                    <div class="name">
                      <h5>{{oneReply.creatorData.creatorName}}<span>({{oneReply.creatorData.creatorUserName}})</span>
                      </h5>
                      <h6>{{oneReply.creatorData.creatorCollectionName}}</h6>
                    </div>

                    <div class="delegated-user" *ngIf="oneReply.delegatorData && oneReply.delegatorData.creatorId">
                      <img class="delegated-arrow" src="./assets/images/icons/arrow-delegate-icon.svg">
                      <div class="image-circle" [title]="oneReply.delegatorData.creatorName">
                        <img *ngIf="oneReply.delegatorData.creatorProfilePicture"
                          [src]="oneReply.delegatorData.creatorProfilePicture"
                          (error)="oneReply.delegatorData.creatorProfilePicture = ''" />
                        <span *ngIf="!oneReply.delegatorData.creatorProfilePicture">{{
                          oneReply.delegatorData.creatorName | shortName }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="text-lg-right">
                    <p class="date-time">{{oneReply.created | date:'MMMM dd, hh:mm aaa'}}</p>
                    <p class="time-from">{{oneReply.created | timeAgo}}</p>
                  </div>
                </div>
              </div>
              <div class="reply-content">
                <div class="reply-body">
                  <pre *ngIf="toggleEditReplay !== 'reply-'+oneReply.replyId">{{oneReply.content}}</pre>
                  <div class="comment-control"
                    *ngIf="toggleEditReplay == 'reply-'+oneReply.replyId && (messageDetails.canReply || TaskComment)">
                    <div class="d-flex mb-2" *ngIf='commentAsList.length > 1'>
                      <span class="mr-2">As:</span>
                      <div>
                        <mat-form-field class="comment-as no-validation">
                          <mat-select [(ngModel)]="commentAs">
                            <mat-option *ngFor="let user of commentAsList" [value]="user">
                              <!-- <img class="example-option-img" height="25"
                                                              *ngIf="user.profilePhoto" [src]="user.profilePhoto"
                                                              (error)="user.profilePhoto = ''" />
                                                          <span class="example-option-img" *ngIf="!user.profilePhoto">
                                                              {{ user.fullName | shortName }}
                                                          </span> -->
                              <!-- <span>{{user.currentUser ? "Me" : user.fullName}}</span> -->
                              <span>{{user.currentUser ? ("general.Me" | translate) : user.fullName}}</span>
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <mat-form-field class="no-validation">
                      <textarea matInput maxlength="1000" [(ngModel)]="oneReply.content"
                        (keyup)="textAreaAdjust($event);" (focus)="textAreaAdjust($event);"
                        [placeholder]="oneReply.content"></textarea>
                    </mat-form-field>
                    <div class="btn-container">
                      <button *ngIf="trim(oneReply.content) != ''" class="btn customBtn"
                        [ngClass]="{loading: replyLoading}" (click)="editReply(oneReply, null, oneComment.commentId)">{{
                        'messagesCom.Edit' | translate }}</button>
                    </div>
                  </div>
                </div>
                <div class="reply-actions">
                  <button class="btn" *ngIf="messageDetails.canReply" (click)="canReply('reply-'+oneReply.replyId)">{{
                    'messagesCom.Reply' | translate }}</button>
                  <span class="sep" *ngIf="messageDetails.canReply && oneReply.isCreator"></span>
                  <button class="btn" *ngIf="(messageDetails.canReply || TaskComment) && oneReply.isCreator"
                    (click)="canComment('reply-'+oneReply.replyId)">{{ 'messagesCom.Edit' | translate }}</button>
                </div>
                <!-- Add Reply panel level two -->
                <div class="comment-panel"
                  *ngIf="toggleAddReplay == 'reply-'+oneReply.replyId && (messageDetails.canReply || TaskComment)">
                  <div class="add-comment">
                    <div class="name-with-image">
                      <div class="image-circle">
                        <img *ngIf="currentUser.profilePicture" [src]="currentUser.profilePicture"
                          (error)="currentUser.profilePicture = ''" />
                        <span *ngIf="!currentUser.profilePicture">{{ currentUser.name | shortName }}</span>
                      </div>
                    </div>
                    <div class="comment-control">
                      <div class="d-flex mb-2" *ngIf='commentAsList.length > 1'>
                        <span class="mr-2">As:</span>
                        <div>
                          <mat-form-field class="comment-as no-validation">
                            <mat-select [(ngModel)]="commentAs">
                              <mat-option *ngFor="let user of commentAsList" [value]="user">
                                <!-- <img class="example-option-img" height="25"
                                                                  *ngIf="user.profilePhoto" [src]="user.profilePhoto"
                                                                  (error)="user.profilePhoto = ''" />
                                                              <span class="example-option-img" *ngIf="!user.profilePhoto">
                                                                  {{ user.fullName | shortName }}
                                                              </span>
                                                              <span>{{user.currentUser ? "Me" : user.fullName}}</span> -->
                                <span>{{user.currentUser ? ("general.Me" | translate) : user.fullName}}</span>
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                      <mat-form-field class="no-validation">
                        <textarea matInput maxlength="1000" [(ngModel)]="commentReply" (keyup)="textAreaAdjust($event);"
                          (focus)="textAreaAdjust($event);"
                          [placeholder]="'messagesCom.Type your reply here' | translate"></textarea>
                      </mat-form-field>
                      <div class="btn-container">
                        <button class="btn customBtn" *ngIf="trim(commentReply) != ''"
                          [ngClass]="{loading: replyLoading}"
                          (click)="addReply(oneReply.replyId, oneComment.commentId)">{{ 'messagesCom.Reply' | translate
                          }}</button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End Add Reply panel level two -->

                <ng-container *ngIf="oneReply.haveReplies">
                  <!-- Show Replies Btn -->
                  <div>
                    <button class="btn show-replies"
                      [ngClass]="{'loading black': repliesListLoading == 'loading-' + oneComment.commentId + oneReply.replyId}"
                      (click)="getReplies(oneReply.replyId, oneComment.commentId)">
                      <span *ngIf="!returnRepliesList(oneReply.replyId, oneComment.commentId)">{{
                        'messagesCom.ShowReplies' | translate }}</span>
                      <span *ngIf="returnRepliesList(oneReply.replyId, oneComment.commentId)">{{
                        'messagesCom.HideReplies' | translate }}</span>
                      <svg width="5" height="9" viewBox="0 0 5 9">
                        <path id="show-replies-icon"
                          d="M7839,4398.7l.758-.7,1.742,1.606,1.742-1.6.758.695-2.5,2.3Zm2.5-5.3-1.742,1.606-.758-.7,2.5-2.3,2.5,2.3-.758.7Z"
                          transform="translate(-7839 -4392)" fill="#aaa" />
                      </svg>
                    </button>
                  </div>
                  <!-- End Show Replies Btn -->
                  <div class="replies-list" *ngIf="returnRepliesList(oneReply.replyId, oneComment.commentId)">
                    <div class="reply-item"
                      *ngFor="let secondReply of returnRepliesList(oneReply.replyId, oneComment.commentId); index as indxR;">
                      <div class="comment-panel">
                        <div class="reply-header d-sm-flex justify-content-between align-items-center">
                          <div class="name-with-image mb-3 mb-sm-0">
                            <div class="image-circle">
                              <img *ngIf="secondReply.creatorData.creatorProfilePicture"
                                [src]="secondReply.creatorData.creatorProfilePicture"
                                (error)="secondReply.creatorData.creatorProfilePicture = ''" />
                              <span *ngIf="!secondReply.creatorData.creatorProfilePicture">{{
                                secondReply.creatorData.creatorName | shortName }}</span>
                            </div>
                            <div class="name">
                              <h5>
                                {{secondReply.creatorData.creatorName}}<span>({{secondReply.creatorData.creatorUserName}})</span>
                              </h5>
                              <h6>{{secondReply.creatorData.creatorCollectionName}}</h6>
                            </div>

                            <div class="delegated-user"
                              *ngIf="secondReply.delegatorData && secondReply.delegatorData.creatorId">
                              <img class="delegated-arrow" src="./assets/images/icons/arrow-delegate-icon.svg">
                              <div class="image-circle" [title]="secondReply.delegatorData.creatorName">
                                <img *ngIf="secondReply.delegatorData.creatorProfilePicture"
                                  [src]="secondReply.delegatorData.creatorProfilePicture"
                                  (error)="secondReply.delegatorData.creatorProfilePicture = ''" />
                                <span *ngIf="!secondReply.delegatorData.creatorProfilePicture">{{
                                  secondReply.delegatorData.creatorName | shortName }}</span>
                              </div>
                            </div>
                          </div>
                          <div class="text-lg-right">
                            <p class="date-time">{{secondReply.created | date:'MMMM dd, hh:mm aaa'}}</p>
                            <p class="time-from">{{secondReply.created | timeAgo}}</p>
                          </div>

                        </div>
                      </div>
                      <div class="reply-content">
                        <div class="reply-body">
                          <pre *ngIf="toggleEditReplay !== 'reply-'+secondReply.replyId">{{secondReply.content}}</pre>
                          <div class="comment-control"
                            *ngIf="toggleEditReplay == 'reply-'+secondReply.replyId && messageDetails.canReply">
                            <div class="d-flex mb-2" *ngIf='commentAsList.length > 1'>
                              <span class="mr-2">As:</span>
                              <div>
                                <mat-form-field class="comment-as no-validation">
                                  <mat-select [(ngModel)]="commentAs">
                                    <mat-option *ngFor="let user of commentAsList" [value]="user">
                                      <!-- <img class="example-option-img" height="25"
                                                                              *ngIf="user.profilePhoto" [src]="user.profilePhoto"
                                                                              (error)="user.profilePhoto = ''" />
                                                                          <span class="example-option-img" *ngIf="!user.profilePhoto">
                                                                              {{ user.fullName | shortName }}
                                                                          </span>
                                                                          <span>{{user.currentUser ? "Me" : user.fullName}}</span> -->
                                      <span>{{user.currentUser ? ("general.Me" | translate) : user.fullName}}</span>
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>
                            </div>
                            <mat-form-field class="no-validation">
                              <textarea matInput maxlength="1000" [(ngModel)]="secondReply.content"
                                (keyup)="textAreaAdjust($event);" (focus)="textAreaAdjust($event);"
                                [placeholder]="secondReply.content"></textarea>
                            </mat-form-field>
                            <div class="btn-container">
                              <button *ngIf="trim(secondReply.content) != ''" class="btn customBtn"
                                [ngClass]="{loading: replyLoading}"
                                (click)="editReply(secondReply, oneComment.commentId, oneComment.commentId)">{{
                                'messagesCom.Edit' | translate }}</button>
                            </div>
                          </div>
                        </div>
                        <div class="reply-actions">
                          <button class="btn" *ngIf="messageDetails.canReply"
                            (click)="canReply('reply-'+secondReply.replyId)">{{ 'messagesCom.Reply' | translate
                            }}</button>
                          <span class="sep" *ngIf="messageDetails.canReply && secondReply.isCreator"></span>
                          <button class="btn" *ngIf="messageDetails.canReply && secondReply.isCreator"
                            (click)="canComment('reply-'+secondReply.replyId)">{{ 'messagesCom.Edit' | translate
                            }}</button>
                        </div>
                        <!-- Add Reply panel level two -->
                        <div class="comment-panel"
                          *ngIf="toggleAddReplay == 'reply-'+secondReply.replyId && messageDetails.canReply">
                          <div class="add-comment">
                            <div class="name-with-image">
                              <div class="image-circle">
                                <img *ngIf="currentUser.profilePicture" [src]="currentUser.profilePicture"
                                  (error)="currentUser.profilePicture = ''" />
                                <span *ngIf="!currentUser.profilePicture">{{ currentUser.name | shortName
                                  }}</span>
                              </div>
                            </div>
                            <div class="comment-control">
                              <div class="d-flex mb-2" *ngIf='commentAsList.length > 1'>
                                <span class="mr-2">As:</span>
                                <div>
                                  <mat-form-field class="comment-as no-validation">
                                    <mat-select [(ngModel)]="commentAs">
                                      <mat-option *ngFor="let user of commentAsList" [value]="user">
                                        <!-- <img class="example-option-img" height="25"
                                                                                  *ngIf="user.profilePhoto" [src]="user.profilePhoto"
                                                                                  (error)="user.profilePhoto = ''" />
                                                                              <span class="example-option-img" *ngIf="!user.profilePhoto">
                                                                                  {{ user.fullName | shortName }}
                                                                              </span>
                                                                              <span>{{user.currentUser ? "Me" : user.fullName}}</span> -->
                                        <span>{{user.currentUser ? ("general.Me" | translate) : user.fullName}}</span>
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </div>
                              </div>
                              <mat-form-field class="no-validation">
                                <textarea matInput maxlength="1000" [(ngModel)]="commentReply"
                                  (keyup)="textAreaAdjust($event);" (focus)="textAreaAdjust($event);"
                                  [placeholder]="'messagesCom.Type your reply here' | translate"></textarea>
                              </mat-form-field>
                              <div class="btn-container">
                                <button class="btn customBtn" *ngIf="trim(commentReply) != ''"
                                  [ngClass]="{loading: replyLoading}"
                                  (click)="addReply(secondReply.replyId, oneComment.commentId)">{{ 'messagesCom.Reply' |
                                  translate }}</button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- End Add Reply panel level two -->


                        <ng-container *ngIf="secondReply.haveReplies">
                          <!-- Show Replies Btn -->
                          <div>
                            <button class="btn show-replies"
                              [ngClass]="{'loading black': repliesListLoading == 'loading-' + oneComment.commentId + secondReply.replyId}"
                              (click)="getReplies(secondReply.replyId, oneComment.commentId)">
                              <span *ngIf="!returnRepliesList(secondReply.replyId, oneComment.commentId)">{{
                                'messagesCom.ShowReplies' | translate }}</span>
                              <span *ngIf="returnRepliesList(secondReply.replyId, oneComment.commentId)">{{
                                'messagesCom.HideReplies' | translate }}</span>
                              <svg width="5" height="9" viewBox="0 0 5 9">
                                <path id="show-replies-icon"
                                  d="M7839,4398.7l.758-.7,1.742,1.606,1.742-1.6.758.695-2.5,2.3Zm2.5-5.3-1.742,1.606-.758-.7,2.5-2.3,2.5,2.3-.758.7Z"
                                  transform="translate(-7839 -4392)" fill="#aaa" />
                              </svg>
                            </button>
                          </div>
                          <!-- End Show Replies Btn -->
                          <div class="replies-list"
                            *ngIf="returnRepliesList(secondReply.replyId, oneComment.commentId)">
                            <div class="reply-item"
                              *ngFor="let thirdReply of returnRepliesList(secondReply.replyId, oneComment.commentId); index as indxR;">
                              <div class="comment-panel">
                                <div class="reply-header d-sm-flex justify-content-between align-items-center">
                                  <div class="name-with-image mb-3 mb-sm-0">
                                    <div class="image-circle">
                                      <img *ngIf="thirdReply.creatorData.creatorProfilePicture"
                                        [src]="thirdReply.creatorData.creatorProfilePicture"
                                        (error)="thirdReply.creatorData.creatorProfilePicture = ''" />
                                      <span *ngIf="!thirdReply.creatorData.creatorProfilePicture">{{
                                        thirdReply.creatorData.creatorName | shortName }}</span>
                                    </div>
                                    <div class="name">
                                      <h5>
                                        {{thirdReply.creatorData.creatorName}}<span>({{thirdReply.creatorData.creatorUserName}})</span>
                                      </h5>
                                      <h6>{{thirdReply.creatorData.creatorCollectionName}}</h6>
                                    </div>

                                    <div class="delegated-user"
                                      *ngIf="thirdReply.delegatorData && thirdReply.delegatorData.creatorId">
                                      <img class="delegated-arrow" src="./assets/images/icons/arrow-delegate-icon.svg">
                                      <div class="image-circle" [title]="thirdReply.delegatorData.creatorName">
                                        <img *ngIf="thirdReply.delegatorData.creatorProfilePicture"
                                          [src]="thirdReply.delegatorData.creatorProfilePicture"
                                          (error)="thirdReply.delegatorData.creatorProfilePicture = ''" />
                                        <span *ngIf="!thirdReply.delegatorData.creatorProfilePicture">{{
                                          thirdReply.delegatorData.creatorName | shortName }}</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="text-lg-right">
                                    <p class="date-time">{{thirdReply.created | date:'MMMM dd, hh:mm aaa'}}</p>
                                    <p class="time-from">{{thirdReply.created | timeAgo}}</p>
                                  </div>
                                </div>
                              </div>
                              <div class="reply-content">
                                <div class="reply-body">
                                  <pre
                                    *ngIf="toggleEditReplay !== 'reply-'+thirdReply.replyId">{{thirdReply.content}}</pre>
                                  <div class="comment-control"
                                    *ngIf="toggleEditReplay == 'reply-'+thirdReply.replyId && messageDetails.canReply">
                                    <div class="d-flex mb-2" *ngIf='commentAsList.length > 1'>
                                      <span class="mr-2">As:</span>
                                      <div>
                                        <mat-form-field class="comment-as no-validation">
                                          <mat-select [(ngModel)]="commentAs">
                                            <mat-option *ngFor="let user of commentAsList" [value]="user">
                                              <!-- <img class="example-option-img" height="25"
                                                                                              *ngIf="user.profilePhoto" [src]="user.profilePhoto"
                                                                                              (error)="user.profilePhoto = ''" />
                                                                                          <span class="example-option-img" *ngIf="!user.profilePhoto">
                                                                                              {{ user.fullName | shortName }}
                                                                                          </span>
                                                                                          <span>{{user.currentUser ? "Me" : user.fullName}}</span> -->
                                              <span>{{user.currentUser ? ("general.Me" | translate) :
                                                user.fullName}}</span>
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                      </div>
                                    </div>
                                    <mat-form-field class="no-validation">
                                      <textarea matInput maxlength="1000" [(ngModel)]="thirdReply.content"
                                        (keyup)="textAreaAdjust($event);" (focus)="textAreaAdjust($event);"
                                        [placeholder]="thirdReply.content"></textarea>
                                    </mat-form-field>
                                    <div class="btn-container">
                                      <button *ngIf="trim(thirdReply.content) != ''" class="btn customBtn"
                                        [ngClass]="{loading: replyLoading}"
                                        (click)="editReply(thirdReply, oneComment.commentId, secondReply.replyId)">{{
                                        'messagesCom.Edit' | translate }}</button>
                                    </div>
                                  </div>
                                </div>
                                <div class="reply-actions">
                                  <button class="btn" *ngIf="messageDetails.canReply"
                                    (click)="canReply('reply-'+thirdReply.replyId)">{{ 'messagesCom.Reply' | translate
                                    }}</button>
                                  <span class="sep" *ngIf="messageDetails.canReply && thirdReply.isCreator"></span>
                                  <button class="btn" *ngIf="messageDetails.canReply && thirdReply.isCreator"
                                    (click)="canComment('reply-'+thirdReply.replyId)">{{ 'messagesCom.Edit' | translate
                                    }}</button>
                                </div>
                                <!-- Add Reply panel level three -->
                                <div class="comment-panel"
                                  *ngIf="toggleAddReplay == 'reply-'+thirdReply.replyId && messageDetails.canReply">
                                  <div class="add-comment">
                                    <div class="name-with-image">
                                      <div class="image-circle">
                                        <img *ngIf="currentUser.profilePicture" [src]="currentUser.profilePicture"
                                          (error)="currentUser.profilePicture = ''" />
                                        <span *ngIf="!currentUser.profilePicture">{{ currentUser.name | shortName }}</span>
                                      </div>
                                    </div>
                                    <div class="comment-control">
                                      <div class="d-flex mb-2" *ngIf='commentAsList.length > 1'>
                                        <span class="mr-2">As:</span>
                                        <div>
                                          <mat-form-field class="comment-as no-validation">
                                            <mat-select [(ngModel)]="commentAs">
                                              <mat-option *ngFor="let user of commentAsList" [value]="user">
                                                <!-- <img class="example-option-img" height="25"
                                                                                                  *ngIf="user.profilePhoto" [src]="user.profilePhoto"
                                                                                                  (error)="user.profilePhoto = ''" />
                                                                                              <span class="example-option-img" *ngIf="!user.profilePhoto">
                                                                                                  {{ user.fullName | shortName }}
                                                                                              </span>
                                                                                              <span>{{user.currentUser ? "Me" : user.fullName}}</span> -->
                                                <span>{{user.currentUser ? ("general.Me" | translate) :
                                                  user.fullName}}</span>
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                      </div>
                                      <mat-form-field class="no-validation">
                                        <textarea matInput maxlength="1000" [(ngModel)]="commentReply"
                                          (keyup)="textAreaAdjust($event);" (focus)="textAreaAdjust($event);"
                                          [placeholder]="'messagesCom.Type your reply here' | translate"></textarea>
                                      </mat-form-field>
                                      <div class="btn-container">
                                        <button class="btn customBtn" *ngIf="trim(commentReply) != ''"
                                          [ngClass]="{loading: replyLoading}"
                                          (click)="addReply(thirdReply.replyId, oneComment.commentId)">{{
                                          'messagesCom.Reply' | translate }}</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- End Add Reply panel level three -->

                                <ng-container *ngIf="thirdReply.haveReplies">
                                  <!-- Show Replies Btn -->
                                  <div>
                                    <button class="btn show-replies"
                                      [ngClass]="{'loading black': repliesListLoading == 'loading-' + oneComment.commentId + thirdReply.replyId}"
                                      (click)="getReplies(thirdReply.replyId, oneComment.commentId)">
                                      <span *ngIf="!returnRepliesList(thirdReply.replyId, oneComment.commentId)">{{
                                        'messagesCom.ShowReplies' | translate }}</span>
                                      <span *ngIf="returnRepliesList(thirdReply.replyId, oneComment.commentId)">{{
                                        'messagesCom.HideReplies' | translate }}</span>
                                      <svg width="5" height="9" viewBox="0 0 5 9">
                                        <path id="show-replies-icon"
                                          d="M7839,4398.7l.758-.7,1.742,1.606,1.742-1.6.758.695-2.5,2.3Zm2.5-5.3-1.742,1.606-.758-.7,2.5-2.3,2.5,2.3-.758.7Z"
                                          transform="translate(-7839 -4392)" fill="#aaa" />
                                      </svg>
                                    </button>
                                  </div>
                                  <!-- End Show Replies Btn -->
                                  <div class="replies-list"
                                    *ngIf="returnRepliesList(thirdReply.replyId, oneComment.commentId)">
                                    <div class="reply-item"
                                      *ngFor="let fourthReply of returnRepliesList(thirdReply.replyId, oneComment.commentId); index as indxR;">
                                      <div class="comment-panel">
                                        <div class="reply-header d-sm-flex justify-content-between align-items-center">
                                          <div class="name-with-image mb-3 mb-sm-0">
                                            <div class="image-circle">
                                              <img *ngIf="fourthReply.creatorData.creatorProfilePicture"
                                                [src]="fourthReply.creatorData.creatorProfilePicture"
                                                (error)="fourthReply.creatorData.creatorProfilePicture = ''" />
                                              <span *ngIf="!fourthReply.creatorData.creatorProfilePicture">{{
                                                fourthReply.creatorData.creatorName | shortName }}</span>
                                            </div>
                                            <div class="name">
                                              <h5>
                                                {{fourthReply.creatorData.creatorName}}<span>({{fourthReply.creatorData.creatorUserName}})</span>
                                              </h5>
                                              <h6>{{fourthReply.creatorData.creatorCollectionName}}</h6>
                                            </div>

                                            <div class="delegated-user"
                                              *ngIf="fourthReply.delegatorData && fourthReply.delegatorData.creatorId">
                                              <img class="delegated-arrow"
                                                src="./assets/images/icons/arrow-delegate-icon.svg">
                                              <div class="image-circle" [title]="fourthReply.delegatorData.creatorName">
                                                <img *ngIf="fourthReply.delegatorData.creatorProfilePicture"
                                                  [src]="fourthReply.delegatorData.creatorProfilePicture"
                                                  (error)="fourthReply.delegatorData.creatorProfilePicture = ''" />
                                                <span *ngIf="!fourthReply.delegatorData.creatorProfilePicture">{{
                                                  fourthReply.delegatorData.creatorName | shortName }}</span>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="text-lg-right">
                                            <p class="date-time">{{fourthReply.created | date:'MMMM dd, hh:mm aaa'}}</p>
                                            <p class="time-from">{{fourthReply.created | timeAgo}}</p>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="reply-content">
                                        <div class="reply-body">
                                          <pre
                                            *ngIf="toggleEditReplay !== 'reply-'+fourthReply.replyId">{{fourthReply.content}}</pre>
                                          <div class="comment-control"
                                            *ngIf="toggleEditReplay == 'reply-'+fourthReply.replyId && messageDetails.canReply">
                                            <div class="d-flex mb-2" *ngIf='commentAsList.length > 1'>
                                              <span class="mr-2">As:</span>
                                              <div>
                                                <mat-form-field class="comment-as no-validation">
                                                  <mat-select [(ngModel)]="commentAs">
                                                    <mat-option *ngFor="let user of commentAsList" [value]="user">
                                                      <!-- <img class="example-option-img" height="25"
                                                                          *ngIf="user.profilePhoto" [src]="user.profilePhoto"
                                                                          (error)="user.profilePhoto = ''" />
                                                                      <span class="example-option-img" *ngIf="!user.profilePhoto">
                                                                          {{ user.fullName | shortName }}
                                                                      </span>
                                                                      <span>{{user.currentUser ? "Me" : user.fullName}}</span> -->
                                                      <span>{{user.currentUser ? ("general.Me" | translate) :
                                                        user.fullName}}</span>
                                                    </mat-option>
                                                  </mat-select>
                                                </mat-form-field>
                                              </div>
                                            </div>
                                            <mat-form-field class="no-validation">
                                              <textarea matInput maxlength="1000" [(ngModel)]="fourthReply.content"
                                                (keyup)="textAreaAdjust($event);" (focus)="textAreaAdjust($event);"
                                                [placeholder]="fourthReply.content"></textarea>
                                            </mat-form-field>
                                            <div class="btn-container">
                                              <button *ngIf="trim(fourthReply.content) != ''" class="btn customBtn"
                                                [ngClass]="{loading: replyLoading}"
                                                (click)="editReply(fourthReply, oneComment.commentId, thirdReply.replyId)">{{
                                                'messagesCom.Edit' | translate }}</button>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="reply-actions">
                                          <button class="btn" *ngIf="messageDetails.canReply && fourthReply.isCreator"
                                            (click)="canComment('reply-'+fourthReply.replyId)">{{
                                              'messagesCom.Edit' | translate }}</button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                        </ng-container>

                      </div>
                    </div>
                  </div>
                </ng-container>

              </div>
            </div>
          </div>
        </ng-container>

      </div>

    </div>
  </div>

</div>
